import "core-js/modules/es.object.freeze.js";
import { GradingSchemeId, GradingSchemeType } from "../Constants";
export var OTHER_GRADING_SCHEME = Object.freeze({
  id: GradingSchemeId.other,
  name: 'Other',
  type: GradingSchemeType.other
});